import { isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Vehicle } from '@sm360/widget-commons-vehicle';
import VehicleAccessoriesItemList from 'build-and-quote/components/Summary/components/VehicleAccessories/VehicleAccessoriesItemList.jsx';
import * as Actions from 'build-and-quote/actions/buildAndQuoteActions.js';
import { OPTIONS_AND_ACCESSORIES } from 'build-and-quote/constants/sections.js';
import 'build-and-quote/components/Summary/components/VehicleAccessories/VehicleAccessories.scss';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

class VehicleAccessories extends React.Component {
    constructor(props) {
        super(props);

        this.handleAccessoriesClick = this.handleAccessoriesClick.bind(this);
    }
    handleAccessoriesClick() {
        const { actions, selectedModel } = this.props;
        AnalyticsService.gaTrigger(TAGS.ADD_OR_MODIFY_ACCESSORIES_AND_OPTIONS(selectedModel.model));
        actions.changeBuildAndQuoteSection(OPTIONS_AND_ACCESSORIES.value);
    }
    render() {
        const isVehicleWithOptions = !isEmpty(this.props.selectedAccessories);

        const goAccessoriesButton = (
            <button onClick={this.handleAccessoriesClick} className="sr-link">
                {LocaleService.t(
                    this.props.isVehicleFromInventory ? 'summarySection.SEE_ALL' : 'summarySection.ADD_OR_MODIFY'
                )}
            </button>
        );

        const noAccessoriesSelectedLabel = (
            <div>
                {LocaleService.t('summarySection.no_accessories_selected')}
                <br />
                {goAccessoriesButton}
            </div>
        );

        const noAccessoriesAvailableLabel = <div>{LocaleService.t('summarySection.no_accessories_available')}</div>;

        return (
            <div className="car-accessories">
                <h2 className="accessories-title sr-subtitle-2">
                    {LocaleService.t('summarySection.accessories_title')}
                </h2>
                {this.props.selectedAccessories.length === 0 && !isVehicleWithOptions && noAccessoriesAvailableLabel}
                {!!(this.props.hasAvailableAccessories && !this.props.selectedAccessories.length > 0) &&
                    noAccessoriesSelectedLabel}
                {!!(this.props.selectedAccessories.length > 0) && (
                    <div>
                        <p className="sr-text is-bold is-small accessories-subtitle">
                            {LocaleService.t('summarySection.accessories_subtitle', {
                                count: this.props.selectedAccessories.length,
                            })}
                        </p>
                        <VehicleAccessoriesItemList items={this.props.selectedAccessories} />
                        {!this.props.isVehicleFromInventory && goAccessoriesButton}
                    </div>
                )}
            </div>
        );
    }
}

VehicleAccessories.propTypes = {
    actions: PropTypes.shape({
        changeBuildAndQuoteSection: PropTypes.func.isRequired,
    }).isRequired,
    hasAvailableAccessories: PropTypes.bool.isRequired,
    selectedAccessories: PropTypes.instanceOf(Vehicle.InventoryAccessoriesAndOptionModelV25).isRequired,
    selectedModel: PropTypes.shape({
        hasOptions: PropTypes.bool.isRequired,
        model: PropTypes.string.isRequired,
    }).isRequired,
    isVehicleFromInventory: PropTypes.bool.isRequired,
};

VehicleAccessories.displayName = 'VehicleAccessories';

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    null,
    mapDispatchToProps
)(VehicleAccessories);
export { VehicleAccessories };
